export enum AnalyticsEventNames {
  VideoLibraryButtonClicked = "VideoLibraryButtonClicked",
  VideoLibraryPageViewed = "VideoLibraryPageViewed",
  VideoLibraryCardVideoClicked = "VideoLibraryCardVideoClicked",
  PatientConsentBannerShown = "PatientConsentBannerShown",
  MissingInsuranceInfoBannerShown = "MissingInsuranceInfoBannerShown",
  PatientOutcomesBannerShown = "PatientOutcomesBannerShown",
  OpenBillBannerShown = "OpenBillBannerShown",
  InstallmentPaymentSubmitted = "InstallmentPaymentSubmitted",
  FailedPaymentBannerClicked = "FailedPaymentBannerClicked",
  PatientConsentButtonClicked = "PatientConsentButtonClicked",
  MissingBillingInfoButtonClicked = "MissingBillingInfoButtonClicked",
  PatientOutcomesButtonClicked = "PatientOutcomesButtonClicked",
  OpenBillButtonClicked = "OpenBillButtonClicked",
  impression = "impression",
  interaction = "interaction",
  page_view = "page_view",
  ConsentPageViewed = "ConsentPageViewed",
  ConsentNiptOptInCheckboxClicked = "ConsentNiptOptInCheckboxClicked",
  ConsentNiptOptOutCheckboxClicked = "ConsentNiptOptOutCheckboxClicked",
  ConsentSubmitSucceeded = "ConsentSubmitSucceeded",
  ConsentSubmitFailed = "ConsentSubmitFailed",
  ConsentVideoPlayClicked = "ConsentVideoPlayClicked",
  ChatbotClose = "ChatbotClose",
  ChatbotMaximize = "ChatbotMaximize",
  ChatbotMinimize = "ChatbotMinimize",
  ChatbotMessageSent = "ChatbotMessageSent",
  ChatbotAggressiveTriggered = "ChatbotAggressiveTriggered",
  ChatbotAgentHandoffAccepted = "ChatbotAgentHandoffAccepted",
  ChatbotAgentHandoffDeclined = "ChatbotAgentHandoffDeclined",
  ChatbotAgentHandoffDisconnected = "ChatbotAgentHandoffDisconnected",
  GCLearnMoreButtonClicked = "GCLearnMoreButtonClicked",
  GCLearnMorePageViewed = "GCLearnMorePageViewed",
  ChatbotFeedbackSubmitted = "ChatbotFeedbackSubmitted",
  ChatbotFeedbackPillSelected = "ChatbotFeedbackPillSelected",
  MultiLanguageReportDownloaded = "MultiLanguageReportDownloaded",
  PartialResultsBannerShown = "partialResultsInfo",
  ResultsTrackerShown = "ResultsTrackerShown",
  NpsSurveySubmitted = "NpsSurveySubmitted",
  PhlebotomyPageView = "PhlebotomyPageView",
  PhlebotomyLocationFinderPageView = "PhlebotomyLocationFinderPageView",
  PhlebotomyPhoneOptionsPageView = "PhlebotomyPhoneOptionsPageView",
  PhlebotomyClick = "PhlebotomyClick",
  PhlebotomyFAQClick = "PhlebotomyFAQClick",
  PhlebotomySearchPageView = "PhlebotomySearchPageView",
  PhlebotomySearchPerformed = "PhlebotomySearchPerformed",
  PhlebotomyReminderLinkClicked = "PhlebotomyReminderLinkClicked",
  PhlebotomyReminderPageView = "PhlebotomyReminderPageView",
  PhlebotomyReminderSubmitted = "PhlebotomyReminderSubmitted",
}
